import React, { useState } from 'react';
import { Send } from 'lucide-react';
import api from '../../services/api';
import toast from 'react-hot-toast';

export default function MessageInput({ caseId, onMessageSent, cannedMessages }) {
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSend = async () => {
    if (!message.trim()) return;
    try {
      setLoading(true);
      await api.messages.send(caseId, message);
      setMessage('');
      onMessageSent();
      toast.success('Message sent');
    } catch (error) {
      toast.error('Failed to send message');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="message-input-area">
      <textarea
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        placeholder="Type your message..."
        className="chat-textarea"
      />
      <button className="btn btn-primary" onClick={handleSend} disabled={loading}>
        <Send size={18} />
      </button>
    </div>
  );
}
